export enum MaterialLibPage {
  EXEMPLE_PAGE = "EXEMPLE_PAGE",
  MATERIAL_LIB = "MATERIAL_LIB",
  MATERIAL_LIB_PROJECT = "material-lib-project",
  MATERIAL_LIB_ORGANIZATION = "material-lib-organization",
}
